import { MAIN_GREEN } from "baseStyles";
import { MOBILE_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Wrapper = styled.div`
  margin-top: 20rem;
  width: 192rem;
  height: 63.6rem;
  background: #101010;
  margin-left: -36rem;
  padding-left: 36rem;
  padding-top: 15rem;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    margin-top: 10rem;
    width: 37.5rem;
    height: 60rem;
    margin-left: -20px;
    padding-left: 20px;
    padding-top: 8rem;
  }
`;

export const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  & > div {
    &:nth-child(1) {
      font-weight: 700;
      font-size: 3.2rem;
      line-height: 4.4rem;
    }
    &:nth-child(2) {
      font-weight: 700;
      font-size: 4.8rem;
      line-height: 8.5rem;
    }
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    & > div {
      &:nth-child(1) {
        font-weight: 700;
        font-size: 2.2rem;
        line-height: 3.8rem;
      }
      &:nth-child(2) {
        font-weight: 700;
        font-size: 2.8rem;
        line-height: 5rem;
      }
    }
  }
`;

export const Content = styled.div`
  display: flex;
  margin-top: 6rem;
  justify-content: space-between;
  padding-right: 36rem;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    margin-top: 3rem;
    flex-direction: column;
    padding-right: 20px;
    gap: 4rem;
  }
`;
export const ContentBox = styled.div`
  & > div {
    &:nth-child(1) {
      font-weight: 300;
      font-size: 1.4rem;
      line-height: 2.4rem;
      color: ${MAIN_GREEN};
    }
    &:nth-child(2) {
      font-weight: 700;
      font-size: 3.2rem;
      line-height: 4.4rem;
      display: flex;
      flex-direction: column;
    }
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    & > div {
      &:nth-child(1) {
        font-weight: 300;
        font-size: 1.4rem;
        line-height: 2.4rem;
        color: ${MAIN_GREEN};
      }
      &:nth-child(2) {
        font-weight: 700;
        font-size: 2.2rem;
        line-height: 3.8rem;
        display: block;
      }
    }
  }
`;
